import axios from 'axios';
import querystring from 'querystring';
import {
    FETCH_LANG_CUSTOMER_FOCUS_SUCCESS,
} from '../constants/ActionTypes';

export const fetchLangCustomerFocusSuccess = data => {
    return {
        type: FETCH_LANG_CUSTOMER_FOCUS_SUCCESS,
        payload: data
    }
}

export const fetchLangCustomerFocus = (payload) => {
    const { company, language } = payload;
    let queryString = querystring.stringify({ company, language });
    
    return dispatch => {
        const url = `${process.env.REACT_APP_API_URL}language/customerFocus?${queryString}`;
        axios.get(url, {headers: {"Authorization": `Bearer ${localStorage.getItem('x-access-token')}`}})
        .then(response => {
            let data = {
                visitingResult: response.data.visitingResult,
                planVisit: response.data.planVisit,
                planNoVisit: response.data.planNoVisit,
                noPlanVisit: response.data.noPlanVisit,
                noPlanNoVisit: response.data.noPlanNoVisit,
                avgSalesPerVisit: response.data.avgSalesPerVisit,
                salesNumOfVisit: response.data.salesNumOfVisit,
                avgSalesPerBill: response.data.avgSalesPerBill,
                yearOrderAmt: response.data.yearOrderAmt,
                monthOrderAmt: response.data.monthOrderAmt,
                activity: response.data.activity,
                number: response.data.number,
                salesmanName: response.data.salesmanName,
                date: response.data.date,
                type: response.data.type,
                detail: response.data.detail,
                overdueBill: response.data.overdueBill,
                dueDate: response.data.dueDate,
                billNo: response.data.billNo,
                invNo: response.data.invNo,
                debtAmount: response.data.debtAmount,
                status: response.data.status,
                productStock: response.data.productStock,
                product: response.data.product,
                forward: response.data.forward,
                buy: response.data.buy,
                sale: response.data.sale,
                salesHistory: response.data.salesHistory,
                display: response.data.display,
                itemGroup: response.data.itemGroup,
                productGroup: response.data.productGroup,
                productLine: response.data.productLine,
                productCode: response.data.productCode,
                numberType: response.data.numberType,
                sellingProportion: response.data.sellingProportion,
                productNotBuy: response.data.productNotBuy,
                productOrder: response.data.productOrder,
            }
            
            dispatch(fetchLangCustomerFocusSuccess(data));
        })
        .catch(error => {
            //dispatch(showKpiMessage(error.response));
        })
    }
}